module.exports = __webpack_public_path__ + "static/img/default_avatar.d3e7e77.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/default_avatar.jpg
// module id = jDHD
// module chunks = 8